import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// LanguageProvider is already inside App.tsx — no need to double-wrap
createRoot(document.getElementById("root")!).render(<App />);
